import React from 'react';
import './HomeView.less';
import Button from '../../../common/js/app/Button/Button.jsx';
import ContactForm from '../../contact/ContactForm/ContactForm.jsx';
import { Row, Item, Column } from 'react-plan';
import { Link } from 'react-router';

type Props = {

}

class HomeView extends React.Component {

  description: 'The HomePage View.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="home-view">
        <div className="bg-white-shadow bg-img1">
          <div className="bloc-medium m-t-xl m-b-xxl">
            <Item>
              <h1 className="m-t-xxl m-b txt-center v-center mobile-bold">
                WORLD TOP QUALITY<br />
                SPACE EDUCATION TO ALL PEOPLE<br />
                IN THE WORLD
              </h1>
            </Item>
            <p className="txt-center mobile-bold">Space is frontier for human being as well as dream or hope for all the people.Space technology makes improve human life all over the world by efficiently using it.In particular, it is able to realize safe and peaceful livelihood, high-quality life, and economy development.</p>

          </div>
        </div>
        <div className="bg-blue">
          <div className="bloc-medium  m-t-xxl m-b-xxl">
            <Row justify="space-between">
              <Column size="48%" medium="100%" small="100%" >
                <h3 className="m-t m-b meet-professor">MEET OUR PROFESSOR - NAOKO YAMAZAKI</h3>
                <p className="m-b">Naoko Yamazaki earned a Bachelor of Science degree majored in Aerospace Engineering from the University of Tokyo in March 1993.
                  She spent one year as an exchange student at the University of Maryland in the U.S.from 1994 till 1995.
                  In March 1996, she earned a Master of Science degree majored in Aerospace Engineering from the University of Tokyo.
                  In April 1996, she started working for Japan Aerospace Exploration Agency (JAXA) (former NASDA).
                  In February 1999, she was selected as an astronaut candidate by JAXA and was certified as an astronaut in September 2001.<br />
                  In May 2004, she completed Soyuz-TMA Flight Engineer training at the Yuri Gagarin Cosmonauts Training Center in Star City, Russia.<br />
                  In February 2006, she was certified as Mission Specialist by NASA.<br />
                  On April 5, 2010 Yamazaki was onboard Space Shuttle Discovery as a mission specialist on the crew of STS-131, an assembly & resupply mission to the International Space Station (ISS).She returned to Earth on April 20, 2010.<br />
                  Yamazaki retired from JAXA on August 31, 2011 and has been serving as a member of Japan Space Policy Committee and an adviser of Young Astronaut Club (YAC), a visiting professor at Ritsumeikan University and Joshibi University of Art and Design, etc.</p>
                <Link to="/courses" className="no-underline" ><Button className="m-b">See Available courses</Button></Link>
              </Column>

              <Column size="48%" medium="100%" small="100%" className="m-t-xxl">
                <iframe width="100%" height="350" src="https://www.youtube.com/embed/Az0dvEP2GRU?rel=0" frameBorder="0" allowFullScreen={ true }></iframe>
              </Column>

            </Row>

          </div>
        </div>
        <div className="bg-white bg-img2">
          <div className="bloc-small  m-t-xl m-b-xxl">
            <h2 className="m-t-xl m-b-xxl txt-center">News</h2>
            <Row justify="space-between">
              <Item size="266px" medium="30%" small="100%">
                <Column size="266px" medium="30%" small="100%" className="card">
                  <Link to="/news" hash="#news1" className="full-card-link">
                    <img src={ require('../../../img-layout/news1.jpg') } alt="img-card" />
                    <h4 txt-center={ true }>WORLD SPACE SCHOOL LAUNCHED</h4>
                    <p>World Space School opened its doors on Aug, 31, 2016, offering access to a comprehensive program of top-quality space education to students, engineers, managers, administrators... <Link to="/news" hash="#news1">read more</Link></p>
                  </Link>
                </Column>
              </Item>
              <Item size="266px" medium="30%" small="100%">
                <Column size="266px" medium="30%" small="100%" className="card">
                  <Link to="/news" hash="#news2" className="full-card-link">
                    <img src={ require('../../../img-layout/news2.jpg') } alt="img-card" />
                    <h4 txt-center={ true }>University of Tokyo Professor Nakasuka gives Spacecraft Design Engineering classes</h4>
                    <p>Professor Shinichi Nakasuka of the University of Tokyo is providing Spacecraft Design Engineering classes at World Space School.The course offers an... <Link to="/news" hash="#news2">read more</Link></p>
                  </Link>
                </Column>
              </Item>
              <Item size="266px" medium="30%" small="100%">
                <Column size="266px" medium="30%" small="100%" className="card">
                  <Link to="/news" hash="#news3" className="full-card-link">
                    <img src={ require('../../../img-layout/news3.jpg') } alt="img-card" />
                    <h4 txt-center={ true }>Astronaut Naoko Yamazaki to offer lessons from space mission</h4>
                    <p>Astronaut Naoko Yamazaki will be giving classes as part of the Spacecraft Design Engineering course at World Space School.Topics in this course include... <Link to="/news" hash="#news3">read more</Link></p>
                  </Link>
                </Column>
              </Item>
            </Row>
          </div>
        </div>
        <div className="bg-blue">
          <div className="bloc-course m-t-xl m-b-xxl">
            <h2 className="m-t-xl m-b-xxl txt-center">Available courses</h2>
            <Row justify="space-between">

              <Item size="266px" medium="30%" small="100%">
                <Column size="266px" medium="30%" small="100%" className="card">
                  <Link to="/course/5799c9b4732db5d32485c166" className="no-underline">
                    <img src={ require('../../../img-layout/SpacecraftDesignEngineering600x500-min.jpg') } alt="img-card" />                    
                    <h4 txt-center={ true }>SPACECRAFT DESIGN ENGINERING</h4>
                    <p>This course is an overview of spacecraft design engineering.Topics included in this course are "Fundamentals of orbital mechanics", "Thermal design of satellite" and "Fundamentals of spacecraft attitude dynamics and control".</p>
                  </Link>
                  <Link to="/video/engineering" className="no-underline btn-center" target="_blank"><Button className="m-b">See sample lecture</Button></Link>
                </Column>
              </Item>   

              <Item size="266px" medium="30%" small="100%">
                <Column size="266px" medium="30%" small="100%" className="card">
                  <Link to="/course/5799c9b47c2bb37849d2dc8f" className="no-underline" >
                    <img src={ require('../../../img-layout/MessageFromSpace600x500-min.jpg') } alt="img-card" />
                    <h4 txt-center={ true }>MESSAGE FROM SPACE</h4>
                    <p>This course is a message from astronaut Naoko Yamazaki.Topics included in this course are "indtroduction to International Space Station (ISS) and activities on ISS" and "space exploration and international cooperation".</p>
                  </Link>
                  <Link to="/video/message" className="no-underline btn-center m-t-35" target="_blank"><Button className="m-b">See sample lecture</Button></Link>
                </Column>
              </Item>
              <Item size="266px" medium="30%" small="100%">
                <Column size="266px" medium="30%" small="100%" className="card">
                  <Link to="/course/5799c9b47c2bb37849d2d3cd" className="no-underline" >
                    <img src="https://storage.googleapis.com/worldspaceschool/courses/thumbs/RemoteSensingThumb600.png" alt="img-card" />
                    <h4 txt-center={ true }>Remote Sensing/GIS</h4>
                    <p>This course is an overview of space technology for earth observation. Topics included in this course are "Principal of remote sensing", "Characteristics of electro-magnetic radiation", "Classification of electro-magnetic adiation in wave length", "Image Resolution and Image Interpretation".</p>
                  </Link>
                  <br />
                  <br />  
                                  
                </Column>
              </Item>  
              
            </Row>
          </div>
        </div>

        <div>
          <div className="bloc-large m-t-xl m-b-xl">
            <h2 className="m-t-xl m-b-xxl txt-center">Our partners</h2>
            <Row justify="space-between" align="center">
              <Item className="p txt-center" align="center" medium="50%" small="100%">
                <img className="university-tokyo" src={ require('../../../img-layout/logo1.png') } alt="logo" />
              </Item>
              <Item className="p txt-center" align="center" medium="50%" small="100%" >
                <img src={ require('../../../img-layout/logo2.png') } alt="logo" />
              </Item>
              <Item className="p txt-center" align="center" medium="50%" small="100%">
                <img src={ require('../../../img-layout/logo3.png') } alt="logo" />
              </Item>
              <Item className="p txt-center" medium="50%" align="center" small="100%">
                <img src={ require('../../../img-layout/logo4.png') } alt="logo" />
              </Item>
              { }
            </Row>
          </div>
        </div>
        <div className="bg-contact bg-img3 cacher">
          <div className="bloc-large">
            <div className="p-t-xxl p-b-xl">
              <Row justify="space-around">
                <Item className="contact-bloc" size="40%" medium="100%" small="100%" >
                  <ContactForm />
                </Item>
                <Item size="10%" medium="100%">
                </Item>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default HomeView;

//Unit test entry point
export const HomeViewTest = HomeView;



/** WEBPACK FOOTER **
 ** ./src/js/views/HomeView/HomeView.jsx
 **/